import HttpClient from "./HttpClient";

export class HttpClientFactory {
  private static instance?: HttpClient;

  public static getInstance(): HttpClient {
    if (HttpClientFactory.instance === undefined) {
      HttpClientFactory.instance = new HttpClient();
    }
    return HttpClientFactory.instance;
  }
}

export default HttpClientFactory;
